import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";

import store from "./store/store";
import { EDIT_CARD } from "./store/actions.type";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/signin",
      name: "signin",
      component: Login
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import(/* */ "./views/Settings.vue")
    },
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/b/:boardId",
      name: "home-board",
      component: Home
    },
    {
      path: "/b/:boardId/c/:inBoardId",
      name: "home-card",
      component: Home
    },
    {
      path: "/b/:boardId/card/:cardId",
      name: "home-card-legacy2",
      component: Home
    },
    {
      path: "/card/:id",
      name: "home-card-legacy",
      component: Home,
      beforeEnter: function(to, from, next) {
        const id = to.params.id;
        if (!id) {
          next("/");
          return;
        }

        store.dispatch(EDIT_CARD, parseInt(id));
        next();
      }
    },
    {
      path: "/b/:boardId/list/:listId",
      name: "home-list",
      component: Home
    },
    {
      path: "/b/:boardId/:boardAction",
      name: "home-board-action",
      component: Home
    },
    { path: "*", redirect: "/" }
  ]
});

//lets wait until users.loaded before go to any path
router.beforeEach((to, from, next) => {
  if (store.state.users.loaded) {
    next();
    return;
  }

  const usersLoadedTimeout = setTimeout(() => {
    if (store.state.users.loaded) {
      clearTimeout(usersLoadedTimeout);
      next();
    }
  }, 50);
});

//authorization
router.beforeEach((to, from, next) => {
  const isAuthed = store.getters["users/isAuthed"];
  const toSignIn = to.name == "signin";

  if (toSignIn) {
    if (isAuthed) {
      //мы авторизованы, так что сразу на главную
      next("/");
    } else {
      next();
    }
    return;
  }

  if (isAuthed) {
    //мы авторизованы, так что можно продолжить к нужному ресурсу
    next();
    return;
  }
  next("/signin");
});

export default router;
